import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-mount-lewotobi',
  standalone: true,
  imports: [
    RouterLink,
    FooterComponent,
    StaticSearchComponent,
    CommonHeaderComponent,
  ],
  templateUrl: './mount-lewotobi.component.html',
  styleUrl: './mount-lewotobi.component.scss',
})
export class MountLewotobiComponent {
  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle(
      'Mt Lewotobi Eruption Travel Insurance Updates | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content:
        'World2Cover travel insurance update: Mount Lewotobi eruption causes Bali flight disruptions. Check coverage details, claims process and travel advice.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Mt Lewotobi Eruption Travel Insurance Updates | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover travel insurance update: Mount Lewotobi eruption causes Bali flight disruptions. Check coverage details, claims process',
    });
  }
}
